<template>
  <v-container fluid>
    <v-row>
      <v-col v-show="aboutLoading" class="pt-5" cols="12">
        Loading about information...
      </v-col>

      <v-col v-if="!aboutLoading" cols="12" class="pt-5" v-html="aboutText">
      </v-col>

      <v-col v-if="!aboutLoading && aboutError" cols="12" class="pt-5">
        <NotificationCard title="About Not Loaded!" :message="errorText" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import { GET_ABOUT } from '@/store/mutationsConsts';

import remark from 'remark';
import html from 'remark-html';

const aboutURL = process.env.VUE_APP_ABOUT_URL;

export default {
  name: 'About',
  beforeMount() {
    if (aboutURL) {
      this.loadAbout();
    }
  },
  methods: {
    loadAbout() {
      this.$store.dispatch(GET_ABOUT, aboutURL);
    },
  },
  computed: {
    ...mapState(['about', 'aboutLoading', 'aboutError']),
    aboutMarkdown() {
      return this.about || this.defaultAbout;
    },
    errorText() {
      return `${this.aboutError}. If this error is consistent please report in on the Github page of the project.`;
    },
    aboutText() {
      return remark().use(html).processSync(this.aboutMarkdown).toString();
    },
  },
  data: () => ({
    defaultAbout: `
# About the S3 Browsing Web Frontend

Welcome to the S3 Browsing Web Frontend! This application provides a convenient web interface to browse and download files from an S3 backend, arranged in an easy-to-navigate file tree structure.

## Features of S3 Web Frontend
- **Search Functionality**: Easily search through directories and files.
- **Efficient Loading**: Contents of folders are lazy-loaded to enhance initial rendering times.
- **Navigation**: Utilize the prefix query parameter to navigate directly to a specific folder.
- **Accessibility**: Designed to access public S3 Buckets effectively.

## Contact

For inquiries or support related to this frontend, feel free to reach out to us via email at [sewers@uwyo.edu](mailto:sewers@uwyo.edu). We're here to help!
`,
  }),
};
</script>
